import isNil from 'lodash/isNil'
import {
  BulkGrantAction,
  BulkGrantResultItem,
} from '../../api/dto/user-invitation.dto'
import type { AccessOutcomeStyle } from './AccessResultList'

/** How a grant outcome reads, wherever a run is reported. */
export const GRANT_OUTCOMES: AccessOutcomeStyle<BulkGrantAction>[] = [
  {
    action: BulkGrantAction.Invited,
    label: 'Invited',
    summaryLabel: 'invited',
    tone: 'success',
  },
  {
    action: BulkGrantAction.InvitationResent,
    label: 'Invitation resent',
    summaryLabel: 'sent a new invitation',
    tone: 'success',
  },
  {
    action: BulkGrantAction.RoleAssigned,
    label: 'Granted',
    summaryLabel: 'granted',
    tone: 'success',
  },
  {
    action: BulkGrantAction.Skipped,
    label: 'Skipped',
    summaryLabel: 'skipped',
    tone: 'notice',
  },
  {
    action: BulkGrantAction.Failed,
    label: 'Failed',
    summaryLabel: 'failed',
    tone: 'error',
  },
]

/** The addresses a retry would act on. */
export const failedEmails = (results: BulkGrantResultItem[] | null): string[] =>
  (results ?? [])
    .filter((result) => result.action === BulkGrantAction.Failed)
    .map((result) => result.email)

/**
 * A retry covers only the previously failed subset, so its outcomes replace
 * those addresses in place and the rest of the report survives.
 */
export const mergeRetriedResults = (
  current: BulkGrantResultItem[] | null,
  retried: BulkGrantResultItem[]
): BulkGrantResultItem[] => {
  if (isNil(current)) return retried
  const byEmail = new Map(retried.map((item) => [item.email, item]))
  return current.map((item) => byEmail.get(item.email) ?? item)
}
